
import React from 'react';
import ImageWrapper from "@/components/ImageComponent/ImageWrapper";

const EnquiryCategorySelector = ({ data }) => {
    // Fallback to avoid crashes if data isn't loaded yet
    if (!data) return null;

    const { title, subtitle, items, helpSection } = data;

    const openWhatsApp = () => {
        const referenceText = `Reference: ${window.location.href}`;
        const message = encodeURIComponent(`Hi! I'd like to chat with a Puja Advisor about booking a ceremony.\n\n${referenceText}`);
        window.open(`https://wa.me/919869929292?text=${message}`, '_blank');
    };
    const scrollToBooking = () => {
        document.getElementById('booking-form')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section className="py-12 bg-white px-6">
            <div className="max-w-6xl mx-auto">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-[#8A1C23] mb-4">{title}</h2>
                    <p className="text-lg text-gray-600">
                        {subtitle}
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {items?.map((category, index) => (
                        <div key={index} className="bg-[#FEF8F2] p-6 rounded-lg shadow-md hover:shadow-lg transition">
                            <div className="flex justify-center mb-4">
                                <ImageWrapper src={category.icon} alt={category.title} width={64} height={64} objectFit="contain" />
                            </div>
                            <h3 className="font-semibold text-lg text-[#8A1C23] mb-2 text-center">{category.title}</h3>
                            <p className="text-sm text-gray-600 mb-2 text-center">{category.description}</p>
                            <p className="text-xs text-[#9B7C1D] font-medium mb-4 text-center italic">{category.benefit}</p>
                            <button
                                onClick={scrollToBooking}
                                className="w-full text-[#8A1C23] underline font-medium hover:no-underline transition-all text-center"
                            >
                                Book Now →
                            </button>
                        </div>
                    ))}
                </div>
                {helpSection && (
                    <div className="text-center mt-12 p-6 bg-[#FEF8F2] rounded-lg">
                        <h3 className="font-bold text-[#8A1C23] mb-2">{helpSection.title}</h3>
                        <p className="text-gray-600 mb-4">{helpSection.subtitle}</p>
                        <div className="flex flex-col sm:flex-row justify-center gap-4">
                            <a
                                href={`tel:${helpSection.phone}`}
                                className="bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white py-2 px-6 rounded-md font-medium transition-colors duration-200 shadow-md hover:shadow-lg flex items-center gap-2 justify-center"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                </svg>
                                Call: <br />{helpSection.phoneDisplay}
                            </a>

                            <button
                                onClick={openWhatsApp}
                                className="bg-[#1DA851] hover:bg-[#128C7E] text-white py-3 px-6 rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg flex items-center gap-3 border-0 justify-center"
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    className="flex-shrink-0"
                                >
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.516" />
                                </svg>
                                {helpSection.ctaText}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default EnquiryCategorySelector;